module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "universal-card"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": ("" + (_vm.item.state.color))
    }
  }, [_vm._v("Статус: "), _c('strong', [_vm._v(_vm._s(_vm.item.state.stateName))])]), _c('div', {
    staticClass: "universal-card__body"
  }, [_c('AppPicture', {
    staticClass: "universal-card__pic",
    attrs: {
      "alt": _vm.item.vacancy_name,
      "image": _vm.item.partner_logo
    }
  }), _c('div', {
    staticClass: "universal-card__block"
  }, [(_vm.item.vacancy_name) ? _c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v(_vm._s(_vm.item.vacancy_name))]) : _vm._e(), (_vm.item.state && _vm.item.state.message) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v(_vm._s(_vm.item.state.message))]) : _vm._e(), (_vm.item.date_created) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Дата отклика: "), _c('strong', [_vm._v(_vm._s(_vm.item.date_created))])]) : _vm._e(), (_vm.item.partner_name) ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Организация: "), _c('strong', [_vm._v(_vm._s(_vm.item.partner_name))])]) : _vm._e(), (_vm.item.state.stateId === "invitation") ? _c('AppText', {
    attrs: {
      "mod": "small, no-bottom"
    }
  }, [_vm._v("Дата приглашения на работу: "), _c('strong', [_vm._v(_vm._s(_vm.item.state.stateDate))])]) : _vm._e()], 1), (_vm.item.user_can_cancel && !_vm.item.state.refusal) ? _c('Cancellation', {
    on: {
      "cancel": function($event) {
        return _vm.cancel(_vm.item.id)
      }
    }
  }) : _vm._e(), _c('AppButtonNew', {
    staticClass: "ms-md-auto ui_color__white",
    staticStyle: {
      "flex": "1 0 auto"
    },
    attrs: {
      "to": _vm.linkToVacancy
    }
  }, [_vm._v("Открыть страницу вакансии")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-965eff1c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/FeedbackCard/FeedbackCard.vue
// module id = ffba5fc6088f611cb8ed
// module chunks = 89